import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getQueuesByPlant } from '../../api/production-request-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to access queues.
 *  @param {string} selectedPlant - The selected plant ID
 *  @param {boolean} resourceQueues - Add resource queues to the response
 */
export const useQueues = (selectedPlant, resourceQueues) => {
  const { apiReady } = useApiReady();

  return useQuery({
    queryKey: [QUERY_KEYS.QUEUE_DATA, selectedPlant, { resourceQueues }],
    queryFn: () => getQueuesByPlant(selectedPlant, resourceQueues),
    select: (data) => {
      let newData = [];

      if (resourceQueues)
        newData = data.map((queue) => {
          if (queue?.resourceQueues?.length) {
            return {
              ...queue,
              resourceQueues: queue.resourceQueues.map((rq) => ({
                ...rq,
                id: rq.resourceId,
                description: rq.resource.description,
              })),
            };
          }

          return { ...queue, resourceQueues: [] };
        });

      return newData.length ? newData : data;
    },
    staleTime: Infinity,
    enabled: Boolean(apiReady && selectedPlant),
  });
};
